/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum GetMessagesResult {
  Error = 0,
  Success = 1,
  InvalidCaseId = 2,
  InvalidUser = 3,
}
